import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ahcct_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveAuth(token, user) {
  localStorage.setItem("ahcct_token", token);
  localStorage.setItem("ahcct_user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("ahcct_token");
  localStorage.removeItem("ahcct_user");
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("ahcct_user") || "null");
  } catch {
    return null;
  }
}
